/**
 * URL contract for the saved-view board layout.
 *
 * The board's arrangement (layout, grouping, swimlanes, sort) is expressed as
 * plain named URL parameters, never an encoded blob.
 */

export const LAYOUT_PARAM = 'layout'
export const GROUP_BY_PARAM = 'group_by'
export const SWIMLANE_PARAM = 'swimlane_by'
export const SORT_PARAM = 'sort'

export const LAYOUTS = ['list', 'board'] as const
export type Layout = (typeof LAYOUTS)[number]

export interface BoardUrlParams {
  layout: Layout
  groupBy: string | null
  swimlaneBy: string | null
  sort: string | null
}

function isLayout(value: string | null): value is Layout {
  return value !== null && (LAYOUTS as readonly string[]).includes(value)
}

function readParam(search: URLSearchParams, key: string): string | null {
  return search.get(key)?.trim() || null
}

export function readBoardParams(search: URLSearchParams): BoardUrlParams {
  const rawLayout = search.get(LAYOUT_PARAM)
  return {
    layout: isLayout(rawLayout) ? rawLayout : 'list',
    groupBy: readParam(search, GROUP_BY_PARAM),
    swimlaneBy: readParam(search, SWIMLANE_PARAM),
    sort: readParam(search, SORT_PARAM),
  }
}
